import { Stack } from '../Stack/Stack';
import { Skeletons } from './Skeletons';

interface Props {
  show: boolean;
  size?: 1 | 3 | 7 | 14 | 21;
}

export function Skeleton({ show, size = 7 }: Props) {
  return (
    show && (
      <div>
        {size === 1 && <Skeletons size={1} />}

        {size === 3 && <Skeletons size={3} />}

        {size === 7 && <Skeletons size={7} />}

        {size === 14 && (
          <Stack gap="3rem">
            <Skeletons size={7} />
            <Skeletons size={7} />
          </Stack>
        )}

        {size === 21 && (
          <Stack gap="3rem">
            <Skeletons size={7} />
            <Skeletons size={7} />
            <Skeletons size={7} />
          </Stack>
        )}
      </div>
    )
  );
}
